import React from 'react';
import clsx from 'clsx';

import Refresh from '@mui/icons-material/Refresh';

import styles from './index.module.scss';

const Loading = (props: { className?: string }) => {
  return (
    <span className={clsx(styles.loading, props.className)}>
      <Refresh />
    </span>
  );
};

export default Loading;
